module.exports = __webpack_public_path__ + "static/media/mobile.013d09ab.png";